export default __webpack_public_path__ + "static/media/bg-main.289ff3c1.png";